module.exports = __webpack_public_path__ + "static/media/toyota-logo.feb3bf81.svg";